"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesSchemaMapper = servicesSchemaMapper;
function makeServiceSchema(title) {
    return {
        type: "string",
        oneOf: [
            {
                const: "1",
                title: "Evaluate",
            },
            {
                const: "2",
                title: "Not Needed",
            },
            {
                const: "3",
                title: "Refused",
            },
        ],
        title,
    };
}
function makeServicesSchema(services, withFrequency) {
    const groupedServices = {};
    services.forEach(service => {
        const { shortHand } = service;
        const title = `${service.name} (${shortHand})`;
        groupedServices[shortHand] = makeServiceSchema(title);
        if (withFrequency && withFrequency.includes(shortHand)) {
            groupedServices[`${shortHand.toLowerCase()}Frequency`] = {
                type: "string",
                title: `${shortHand} Frequency`,
            };
        }
    });
    return groupedServices;
}
function servicesSchemaMapper(template, services, serviceFrequencies) {
    template.schema.properties.services.properties = makeServicesSchema(services, serviceFrequencies);
    return template;
}
